/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export enum AppSnackbarAktion {
    NeuLaden = 1,
    NeuAnmelden = 2,
    ZurHauptseite = 3,
}
